/**
 * Invitation landing (/invite-user and /invite-existing-user).
 *
 * Under single sign-on the invited person sets their password at the identity
 * provider (via the activation email), so this page collects NO credentials. It
 * exists only so the invitation link lands on a coherent in-product page instead
 * of a dead route, and points the invitee to sign in.
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import { Button, Stack, Typography } from '@mui/material';
import { MarkEmailReadRounded } from '@mui/icons-material';
import PublicShell from './PublicShell';
import { goToSignIn } from './signIn';

export const InviteLandingPage: React.FC = () => {
  const translate = useTranslate();
  const location = useLocation();
  const isExisting = location.pathname.endsWith('/invite-existing-user');

  return (
    <PublicShell>
      <Stack spacing={2} alignItems="center" sx={{ py: 2, textAlign: 'center' }}>
        <MarkEmailReadRounded sx={{ fontSize: 56, color: 'primary.main' }} />
        <Typography variant="h6" fontWeight={700}>
          {translate('onboarding.invite.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate(isExisting ? 'onboarding.invite.body_existing' : 'onboarding.invite.body')}
        </Typography>
        <Button variant="contained" onClick={goToSignIn} sx={{ mt: 1 }}>
          {translate('onboarding.invite.go_to_sign_in')}
        </Button>
      </Stack>
    </PublicShell>
  );
};

export default InviteLandingPage;
